import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "tw-text-center tw-mb-10 tw-text-4xl tw-font-bold" }
const _hoisted_2 = { class: "tw-text-center tw-mb-10 tw-text-xl" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "You are currently logged out.", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Please login and try again.", -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "There is an error in the data you have entered.", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "Please try again.", -1)
const _hoisted_10 = { key: 2 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, "There was an error with your request", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, "Please try again.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContactLink = _resolveComponent("ContactLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.errorTitle), 1),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.errorCode == 'loggedout')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
        : (_ctx.errorCode == 'baddata')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              _hoisted_9,
              _createElementVNode("p", null, [
                _createTextVNode(" If the problem persists please "),
                _createVNode(_component_ContactLink, {
                  onContact: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                }),
                _createTextVNode(". ")
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", null, [
                _hoisted_11,
                _hoisted_12,
                _createElementVNode("p", null, [
                  _createTextVNode(" If the problem persists please "),
                  _createVNode(_component_ContactLink, {
                    onContact: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
                  }),
                  _createTextVNode(". ")
                ])
              ])
            ]))
    ])
  ], 64))
}